export const FETCH_QUEUE_LIST = "FETCH_QUEUE_LIST";
export const CREATE_QUEUE = "CREATE_QUEUE";
export const UPDATE_QUEUE = "UPDATE_QUEUE";
